export class ReducerRegistry {
  constructor() {
    this.emitChange = null;
    this.reducers = {};
  }

  getReducers() {
    return { ...this.reducers };
  }

  register(name, reducer) {
    if (this.reducers[name]) return;
    this.reducers = { ...this.reducers, [name]: reducer };
    if (this.emitChange) this.emitChange(this.getReducers());
  }

  setChangeListener(listener) {
    this.emitChange = listener;
  }
}

export default new ReducerRegistry();
